'use client';

import {
	Box, Grid, GridItem, useSlotRecipe,   Text,

} from '@chakra-ui/react';
import type {
	GridItemProps, GridProps, BoxProps,
} from '@chakra-ui/react';
import React from 'react';
import type { PropsWithChildren } from 'react';

const DataTableRoot = ({ children, ...boxProps }: PropsWithChildren<BoxProps>) => {
	const recipe = useSlotRecipe({ key: 'dataTable' });
	const styles = recipe();

	return (
		<Box css={styles.root} {...boxProps}>
			{children}
		</Box>
	);
};

type DataTableHeaderProps = {
	title: React.ReactNode
} & BoxProps;

const DataTableHeader = ({ children, title, ...boxProps }: PropsWithChildren<DataTableHeaderProps>) => {
	const recipe = useSlotRecipe({ key: 'dataTable' });
	const styles = recipe();

	return (
		<Box css={styles.header} {...boxProps}>
			<Text>
				{title}
			</Text>
			{children}
		</Box>
	);
};

const DataTableBody = ({ children, ...boxProps }: PropsWithChildren<BoxProps>) => {
	return (
		<Box {...boxProps}>
			{children}
		</Box>
	);
};

const DataTableRow = ({ children, ...gridProps }: PropsWithChildren<GridProps>) => {
	const recipe = useSlotRecipe({ key: 'dataTable' });
	const styles = recipe();

	return (
		<Grid css={styles.row} gridTemplateColumns="300px 1fr" {...gridProps}>
			{children}
		</Grid>
	);
};

const DataTableCell = ({ children, ...gridItemProps }: PropsWithChildren<GridItemProps>) => {
	const recipe = useSlotRecipe({ key: 'dataTable' });
	const styles = recipe();

	return (
		<GridItem css={styles.cell} {...gridItemProps}>
			{children}
		</GridItem>
	);
};

export const DataTable = {
	Body:   DataTableBody,
	Cell:   DataTableCell,
	Header: DataTableHeader,
	Root:   DataTableRoot,
	Row:    DataTableRow,
};
